import _objectWithoutProperties from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DETOX-SHOP218-JOB1/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title", "titleId"];
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
function Entertainment(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15.107 1.1c.443.143.997.495 1.346 1.342.45.13 1.014.393 1.417.919.223.292.452.74.472 1.369.68.429 1.381 1.153 1.456 2.158.588.368 1.33 1.018 1.383 1.976.049.855-.462 1.632-1.518 2.312l-1.795 10.977a1 1 0 01-.987.84H7.21a1 1 0 01-.986-.84L4.443 11.265c-.54-.272-1.24-.776-1.408-1.607-.096-.475-.035-1.173.7-1.936.04-.651.214-1.757.901-2.464.191-.196.408-.35.645-.456.14-.556.44-1.283 1.083-1.755a2.294 2.294 0 011.487-.45c.334-.414.87-.9 1.616-1.054.482-.1 1.196-.084 2.008.464l.844-.15c.512-.396 1.66-1.123 2.788-.756zM7.81 11.554l-1.293.001 1.543 9.438h.556l-.806-9.439zm6.46 0h-1.225v9.438h.419l.806-9.438zm-3.225 0H9.819l.806 9.438h.42v-9.438zm6.53.001h-1.296l-.806 9.437.558.001 1.544-9.438zm-4.162-8.01c-.137.12-.307.203-.487.236l-1.533.273a1.001 1.001 0 01-.83-.228c-.16-.14-.46-.367-.69-.323-.272.053-.555.447-.642.618-.214.42-.693.639-1.152.522-.248-.066-.426-.06-.53.017-.255.187-.38.786-.39 1.004a1 1 0 01-1 .955c-.33.282-.445 1.058-.435 1.522.007.306-.126.6-.36.795a1.66 1.66 0 00-.33.343c.1.09.301.204.475.276h12.979c.53-.322.665-.539.693-.594l.006-.014c-.049-.1-.463-.405-.819-.554a1.006 1.006 0 01-.587-1.167c.148-.59-.834-.97-.843-.974a1.006 1.006 0 01-.628-1.154c.037-.17.064-.398-.026-.52-.125-.165-.492-.255-.66-.267a1.016 1.016 0 01-.923-.782c-.076-.346-.17-.476-.204-.515l-.014-.014c-.153-.047-.685.208-1.07.545zm1.982 2.581a1 1 0 11-1.046 1.705c-.767-.47-1.746.465-1.755.475-.338.328-.865.38-1.258.12-.126-.084-.507-.338-.92.237a1.01 1.01 0 01-1.388.241.993.993 0 01-.26-1.374c.515-.76 1.669-1.555 2.983-1.114.897-.626 2.291-1.12 3.644-.29z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}
var MemoEntertainment = React.memo(Entertainment);
export default MemoEntertainment;